import IEventService from '../../../services/eventService/IEventService';
import EventNames from '../../../config/eventNames';
import { getServices } from '../../../infra/startup';
import * as T from '@clientos/types';
import { internalLogger } from '../clientOsLogger';

export default class EventInterface implements T.EventsInterfaceType {
  private _eventService: IEventService;
  //@ts-expect-error We need to update the EventName in types
  public shellEventNames: typeof EventNames;

  constructor() {
    const services = getServices();
    this._eventService = services.eventService;
    this.shellEventNames = this._eventService.eventNames;
  }

  addEventListener(name: string, action: T.EventCallBackType): void {
    this._eventService.addEventListener(name, action);
  }

  removeEventListener(name: string, action: T.EventCallBackType): void {
    this._eventService.removeEventListener(name, action);
  }

  triggerEvent(name: string, event: T.EventValueType): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._eventService.publish(name, event);
  }
}

export function createNoopEventInterface(): T.EventsInterfaceType {
  return {
    //@ts-expect-error We need to update the EventName in types
    shellEventNames: EventNames,
    addEventListener: function (): void {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopEventInterface',
        methodName: 'addEventListener()',
        message: 'Noop interface method called - no operation performed'
      });
    },
    removeEventListener: function (): void {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopEventInterface',
        methodName: 'removeEventListener()',
        message: 'Noop interface method called - no operation performed'
      });
    },
    triggerEvent: function (): void {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopEventInterface',
        methodName: 'triggerEvent()',
        message: 'Noop interface method called - no operation performed'
      });
    }
  };
}
